<script lang="ts">
import { defineComponent } from "vue";
import DbButton from "../DB-Components/DbButton.vue";
import MyTravelLarge from "@/components/icons/MyTravelLarge.vue";

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["hideModal", "cancel"],
  setup(props, context) {
    const close = () => {
      context.emit("hideModal");
    };
    const submit = () => {
      context.emit("cancel");
    };
    return {
      close,
      submit,
    };
  },
  components: { DbButton, MyTravelLarge },
});
</script>
<template>
  <div
    id="counter-cancellation-needed-modal"
    :class="visible ? 'flex' : 'hidden'"
    tabindex="-1"
    class="fixed top-0 left-0 right-0 bottom-0 px-5 flex items-center justify-center z-50"
  >
    <div class="relative w-full max-w-xl max-h-full z-50">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow">
        <!-- Modal body -->
        <div class="p-6 flex flex-col w-full" data-testid="test-cancel-tour">
          <MyTravelLarge color="red"></MyTravelLarge>
          <p class="text-red-500">
            {{ $t("tour.counter_cancellation_needed") }}
          </p>
        </div>
        <div class="py-3 flex flex-wrap justify-center gap-1">
          <DbButton
            @on-click="close"
            class="hydrated button-gap"
            variant="secondary-solid"
            >{{ $t("order.cancel") }}</DbButton
          >
          <DbButton @on-click="submit" class="hydrated px-4">{{
            $t("order.discard_task")
          }}</DbButton>
        </div>
      </div>
    </div>
    <div
      modal-backdrop=""
      :class="visible ? 'flex' : 'hidden'"
      class="bg-gray-900 bg-opacity-50 fixed inset-0 z-40"
    ></div>
  </div>
</template>
